export default __webpack_public_path__ + "ui/assets/img/cancel-red-24.svg";